module.exports = __webpack_public_path__ + "static/media/preview_stamp_campaigns.9edbcbe7.svg";